<template>
	<div>
		<!-- 开启顶部安全区适配 -->
		<van-nav-bar safe-area-inset-top v-if="!$util.getClientType()" />

		<div class="w100 flex-between bg-white align-center f-gray">
			<div class="flex-start align-center">
				<img src="../../static/img/logo-transverse.png" style="height: 60px;" class="ml10" />
				<div class="flex-start" v-if="$util.getClientType()">
					<div class="nav-top" @click="onNavigator('index')">
						<a href="javascript:void(0)" @click.stop="onNavigator('index')">首页</a>
					</div>
					<div class="nav-top" @click="onNavigator('news')">
						<a href="javascript:void(0)" @click.stop="onNavigator('news')">集团资讯</a>
					</div>
					<div class="nav-top" @click="onNavigator('business')">
						<a href="javascript:void(0)" @click.stop="onNavigator('business')">业务领域</a>
					</div>
					<div class="nav-top" @click="onNavigator('recruit')">
						<a href="javascript:void(0)" @click.stop="onNavigator('recruit')">人才招聘</a>
					</div>
					<div class="nav-top" @click="onNavigator('about')">
						<a href="javascript:void(0)" @click.stop="onNavigator('about')">关于我们</a>
					</div>
				</div>
			</div>
			<van-icon name="wap-nav" size="32px" v-if="!$util.getClientType()" class="mr10" @click="onShowDrawer()" />
			<el-drawer title="" :visible.sync="drawer" direction="rtl" size="150px">
				<div>
					<div class="nav-top" @click="onNavigator('index')">
						<a href="javascript:void(0)" @click.stop="onNavigator('index')">首页</a>
					</div>
					<div class="nav-top" @click="onNavigator('news')">
						<a href="javascript:void(0)" @click.stop="onNavigator('news')">集团资讯</a>
					</div>
					<div class="nav-top" @click="onNavigator('business')">
						<a href="javascript:void(0)" @click.stop="onNavigator('business')">业务领域</a>
					</div>
					<div class="nav-top" @click="onNavigator('recruit')">
						<a href="javascript:void(0)" @click.stop="onNavigator('recruit')">人才招聘</a>
					</div>
					<div class="nav-top" @click="onNavigator('about')">
						<a href="javascript:void(0)" @click.stop="onNavigator('about')">关于我们</a>
					</div>
				</div>
			</el-drawer>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawer: false
			}
		},
		methods: {
			onShowDrawer() {
				var _this = this;
				_this.drawer = !_this.drawer;
			},
			onNavigator(name) {
				var _this = this;
				_this.$router.push({
					name: name
				})
			}
		}
	}
</script>

<style>
	.nav-top {
		height: 60px;
		line-height: 60px;
		width: 150px;
		text-align: center;
		font-size: 14px;
		font-weight: bold;
		cursor: pointer;
		color: var(--dark-gray);
	}

	.nav-top:hover {
		background-color: var(--golden);
		color: #ffffff;
	}

	.nav-top:hover a {
		color: #ffffff !important;
	}

	.nav-top a:hover {
		color: #ffffff !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/top.vue